module.exports = __webpack_public_path__ + "img/blue_015.f889d466.png";